<div id="carouselExampleControls" class="carousel slide" data-ride="carousel">
    <div class="carousel-inner">
      <div class="carousel-item active">
        <img class="d-block" src="assets/banner.png">
      </div>
      <div class="carousel-item">
        <img class="d-block" src="https://source.unsplash.com/1600x900/?sanseveria">
      </div>
      <div class="carousel-item">
        <img class="d-block" src="https://source.unsplash.com/1600x900/?aroids">
      </div>
      <div class="carousel-item">
        <img class="d-block" src="https://source.unsplash.com/1600x900/?fern">
      </div>
      <div class="carousel-item">
        <img class="d-block" src="https://source.unsplash.com/1600x900/?heliconia">
      </div>
      <div class="carousel-item">
        <img class="d-block" src="https://source.unsplash.com/1600x900/?alocasia">
      </div>
    </div>
    <a class="carousel-control-prev" href="#carouselExampleControls" role="button" data-slide="prev">
      <span class="carousel-control-prev-icon" aria-hidden="true"></span>
      <span class="sr-only">Previous</span>
    </a>
    <a class="carousel-control-next" href="#carouselExampleControls" role="button" data-slide="next">
      <span class="carousel-control-next-icon" aria-hidden="true"></span>
      <span class="sr-only">Next</span>
    </a>
  </div>
